module.exports = __webpack_public_path__ + "static/media/logo.4a2ed038.png";